import * as turf from '@turf/turf';
import { testDigits, testPhone, testText } from 'utils/form';

export const generatePolygons = (multilineGeojson, widthOfArea, height) => {
  const linesCoordinates = multilineGeojson.coordinates;
  const features = [];
  const line = turf.lineString(linesCoordinates);

  const offsetLine1 = turf.lineOffset(line, parseInt(widthOfArea) / 2, {
    units: 'meters',
  });
  const offsetLine2 = turf.lineOffset(line, (parseInt(widthOfArea) / 2) * -1, {
    units: 'meters',
  });

  for (let i = 0; i <= linesCoordinates.length - 2; i += 1) {
    features.push({
      type: 'Feature',
      properties: {
        width: widthOfArea,
        minHeight: height.min,
        maxHeight: height.max,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            offsetLine1.geometry.coordinates[i],
            offsetLine1.geometry.coordinates[i + 1],
            offsetLine2.geometry.coordinates[i + 1],
            offsetLine2.geometry.coordinates[i],
            offsetLine1.geometry.coordinates[i],
          ],
        ],
      },
    });
  }

  features.push({
    type: 'Feature',
    geometry: multilineGeojson,
    properties: {},
  });
  const generatedGeojson = {
    type: 'FeatureCollection',
    features,
  };

  return generatedGeojson;
};

export const validateData = data => {
  const errors = {};
  if (!validateCheck('othername', data.othername)) errors.othername = true;
  if (!validateCheck('contact', data.contact)) errors.contact = true;
  if (!validateCheck('description', data.description))
    errors.description = true;
  if (!validateCheck('agl_min', data.agl_min)) errors.agl_min = true;
  if (!validateCheck('agl_max', data.agl_max)) errors.agl_max = true;
  if (!validateCheck('geojson', data.geojson)) errors.geojson = true;
  if (!validateCheck('width', data.width)) errors.width = true;
  if (Object.keys(errors).length) return errors;
  return null;
};

export const validateCheck = (name, value) => {
  if (name === 'othername' && testText(value, 3)) return true;
  if (name === 'contact' && testPhone(value, 3, 12)) return true;
  if (name === 'description' && testText(value, 3)) return true;
  if (
    name === 'agl_min' &&
    testDigits(parseInt(value), borderValues.minHeight, borderValues.maxHeight)
  )
    return true;
  if (
    name === 'agl_max' &&
    testDigits(parseInt(value), borderValues.minHeight, borderValues.maxHeight)
  )
    return true;
  if (name === 'geojson' && value) return true;
  if (
    name === 'width' &&
    testDigits(parseInt(value), borderValues.minWidth, borderValues.maxWidth)
  )
    return true;
  return false;
};

export const borderValues = {
  minHeight: 0,
  maxHeight: 500,
  minWidth: 10,
  maxWidth: 150,
};
